import {
  format,
  formatDistanceToNow,
  isToday,
  isYesterday,
  isThisYear,
  parseISO,
} from "date-fns";
import { es } from "date-fns/locale";

export function formatRelativeDate(dateString: string): string {
  const date = parseISO(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);

  if (diffMins < 1) return "ahora mismo";
  if (diffMins < 60) return `hace ${diffMins} minuto${diffMins > 1 ? "s" : ""}`;
  if (diffHours < 24 && isToday(date)) {
    return format(date, "HH:mm", { locale: es });
  }
  if (isYesterday(date)) {
    return `ayer ${format(date, "HH:mm", { locale: es })}`;
  }
  if (isThisYear(date)) {
    return format(date, "d MMM", { locale: es });
  }
  return format(date, "d MMM yyyy", { locale: es });
}

export function formatFullDate(dateString: string): string {
  const date = parseISO(dateString);
  return format(date, "EEEE, d 'de' MMMM 'de' yyyy, HH:mm", { locale: es });
}

export function formatShortDate(dateString: string): string {
  const date = parseISO(dateString);
  if (isToday(date)) return format(date, "HH:mm");
  if (isYesterday(date)) return "Ayer";
  if (isThisYear(date)) return format(date, "d MMM");
  return format(date, "d MMM yy");
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}
